import { render, staticRenderFns } from "./PackageOrderForm.vue?vue&type=template&id=1983599a&scoped=true"
import script from "./PackageOrderForm.vue?vue&type=script&lang=ts"
export * from "./PackageOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./PackageOrderForm.vue?vue&type=style&index=0&id=1983599a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983599a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1983599a')) {
      api.createRecord('1983599a', component.options)
    } else {
      api.reload('1983599a', component.options)
    }
    module.hot.accept("./PackageOrderForm.vue?vue&type=template&id=1983599a&scoped=true", function () {
      api.rerender('1983599a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/PackageOrderForm.vue"
export default component.exports